import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & { icon?: React.ReactNode }
>(({ className, type, icon, ...props }, ref) => {
  return (
    <div className={cn('relative')}>
      <input
        type={type}
        data-slot="input"
        ref={ref}
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          icon ? 'pl-[24px]' : null,
          className
        )}
        {...props}
      />
      <div
        className={cn(
          'absolute',
          'left-[6px]',
          'top-1/2',
          '-translate-y-1/2',
          'w-[16px]'
        )}
      >
        {icon}
      </div>
    </div>
  );
});

Input.displayName = 'Input';

export { Input };
